﻿import {JsonFetchText} from "../../Helper/FetchHelper";
import {ITemplateModel} from "../../Model/Template/ITemplateModel";

export class Preview {
    public static Read = async (model: ITemplateModel) => {
        return JsonFetchText.Post("/process/preview", model)
            .then((result: string) => {
                return result
            });
    }
}